// Generated by CoffeeScript 2.7.0
var Admin__Settings__AdministrationsController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsAdministrations from 'trunks/vue/admin/components/settings/settings_administrations.js';

export default Admin__Settings__AdministrationsController = (function() {
  class Admin__Settings__AdministrationsController extends Skylark.App.BaseController {
    index() {
      this._generateSettingsSidebarView('settings__administrations');
      return Skylark.Libs.Ajax.get('/admin/administrations/actions.json', {
        success: function(data) {
          return new SettingsAdministrations({
            el: DomMaster.find("#js-settings-administrations").node,
            propsData: {
              actionList: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__AdministrationsController.include(GenerateMorePopover);

  Admin__Settings__AdministrationsController.include(SettingsNavigator);

  return Admin__Settings__AdministrationsController;

}).call(this);
